import React from "react";
import classNames from "classnames";

import * as styles from "./SelectRangeItem.module.css";

interface ISelectRangeItemProps {
    label: React.ReactNode;
    isActive: boolean;
    isNonActive: boolean;
    isDisabled?: boolean;
    isFirst?: boolean;
    isLast?: boolean;
    name: string;
    value: number;
    onChange: (name: string, value: number) => void;
    className?: string;
}

export const SelectRangeItem = (props: ISelectRangeItemProps) => {
    const handleClick = () => {
        if (props.isNonActive || props.isDisabled) {
            return;
        }
        props.onChange(props.name, props.value);
    };

    const itemClassName = classNames(
        styles.item,
        {
            [styles.active]: props.isActive && !props.isNonActive,
            [styles.nonActive]: props.isActive && props.isNonActive,
            [styles.disabled]: props.isDisabled,
            [styles.first]: props.isFirst,
            [styles.last]: props.isLast
        },
        props.className
    );

    return (
        <div className={itemClassName} onClick={handleClick}>
            <span>{props.label}</span>
        </div>
    );
};
import React from "react";
import classNames from "classnames";

import * as styles from "./SelectRangeItem.module.css";

interface ISelectRangeItemProps {
    label: React.ReactNode;
    isActive: boolean;
    isNonActive: boolean;
    isDisabled?: boolean;
    isFirst?: boolean;
    isLast?: boolean;
    name: string;
    value: number;
    onChange: (name: string, value: number) => void;
    className?: string;
}

export const SelectRangeItem = (props: ISelectRangeItemProps) => {
    const handleClick = () => {
        if (props.isNonActive || props.isDisabled) {
            return;
        }
        props.onChange(props.name, props.value);
    };

    const itemClassName = classNames(
        styles.item,
        {
            [styles.active]: props.isActive && !props.isNonActive,
            [styles.nonActive]: props.isActive && props.isNonActive,
            [styles.disabled]: props.isDisabled,
            [styles.first]: props.isFirst,
            [styles.last]: props.isLast
        },
        props.className
    );

    return (
        <div className={itemClassName} onClick={handleClick}>
            <span>{props.label}</span>
        </div>
    );
};
